
import { Footer } from "components/ui/Footer";
import Header from "components/ui/Header";
import React from "react";
import { Outlet } from "react-router-dom";

export const LayOut = ({ children }) => {
  return (
    <>
      <Header />
      <main className="min-h-screen">
        {/* If children are passed directly */}
        {children}

        {/* For React Router nested routes */}
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
